module.exports = __webpack_public_path__ + "img/DOT4LV.2e948e8e.png";